import React from 'react'

function Loader() {
  return (
    <div className="loader-wrapper">
        <span className="loader"><span className="loader-inner"></span></span>
    </div>
  )
}

export default Loader